<template>
  <v-row justify="center">
    <v-dialog
      v-model="curVisible"
      scrollable
      max-width="500px"
    >
      <v-card>
        <v-card-title>选择</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="min-height: 50px;margin: 0;padding: 0;">
          <div
            v-if="loading"
            style="text-align: center;
            height: 100px;
            line-height: 100px;">
            正在加载...
          </div>
          <div
            v-else-if="list && list.length === 0"
            style="text-align: center;
            height: 100px;
            line-height: 100px;">
            暂无数据
          </div>
          <v-list v-else style="padding: 0;">
            <v-list-item-group
              v-model="model"
              mandatory
              color="indigo"
              active-class="border"
            >
            <template v-for="(item, i) in list ">
              <v-divider v-if="i !== 0" :key="`divider-${i}`"></v-divider>
              <v-list-item
                v-if="true"
                :key="`item-${i}`"
                @click="changeCode(item)"
              >
                <!-- <v-list-item-icon>
                  <v-icon v-if="item.type === 'ENT'">mdi-film</v-icon>
                  <v-icon v-else>mdi-account-multiple</v-icon>
                </v-list-item-icon> -->
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-if="model === i" color="success">mdi-check</v-icon>
                  <span v-else style="color: #9e9e9e">切换</span>
                </v-list-item-action>
              </v-list-item>
            </template>

            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    curVisible: {
      get() {
        return this.visible
      },
      set(val) {
        var that = this
        that.$emit('update:visible', val)
        if (!val) {
          that.$emit('closed')
        }
      }
    }
  },
  data: () => ({
    model: 0,
    list: [
      { text: 'Q1', value: 'Q1' },
      { text: 'Q2', value: 'Q2' },
      { text: 'Q3', value: 'Q3' },
      { text: 'Q4', value: 'Q4' },
      { text: 'Q5', value: 'Q5' },
      { text: 'Q6', value: 'Q6' },
      { text: 'Q7', value: 'Q7' },
      { text: 'Q8', value: 'Q8' },
      { text: 'Q9', value: 'Q9' },
      { text: 'Q10', value: 'Q10' },
      { text: 'Q11', value: 'Q11' },
      { text: 'Q12', value: 'Q12' },
      { text: 'Q13', value: 'Q13' },
      { text: 'Q14', value: 'Q14' },
      { text: 'Q15', value: 'Q15' },
      { text: 'Q16', value: 'Q16' },
      { text: 'Q17', value: 'Q17' },
      { text: 'Q18', value: 'Q18' },
      { text: 'Q19', value: 'Q19' }
    ],
    loading: false,
    code: ''
  }),
  mounted() {
  },
  methods: {
    async changeCode(item) {
      var that = this
      if (that.code === item.value) {
        that.curVisible = false
        return
      }

      that.code = item.value;
      that.codeToggled(item.value)
    },
    codeToggled(code) {
      var that = this
      that.curVisible = false
      that.$emit('code-toggled', code)
    }
  }
}
</script>
<style scoped>
/* .border {
  border: 2px dashed orange;
} */
</style>
